import React from 'react';
import cn from 'classnames';

import { formatFileSize, getFileExtension } from 'widget/utils/formatters';
import FileIcon from 'widget/shared/icons/FileIcon';
import Typography from 'widget/shared/ui/Typography';
import {
  TypographySize,
  TypographyWeight,
  TypographyColor,
  TypographyTag
} from 'widget/shared/ui/Typography/types';

import styles from './MessageDocument.module.scss';

export type MessageDocumentProps = {
  url: string;
  filename: string;
  size: number;
  variant?: 'default' | 'user';
};

const MessageDocument: React.FC<MessageDocumentProps> = ({
  url,
  filename,
  size,
  variant = 'default'
}) => {
  const extension = getFileExtension(filename);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        styles['document'],
        variant === 'user' && styles['document_user']
      )}
    >
      <FileIcon
        extension={extension || 'FILE'}
        className={styles['document__icon']}
      />
      <div className={styles['document__info']}>
        <Typography
          tag={TypographyTag.span}
          size={TypographySize.s}
          weight={TypographyWeight.medium}
          color={TypographyColor.secondary}
          className={styles['document__filename']}
        >
          {filename}
        </Typography>
        <Typography
          tag={TypographyTag.span}
          size={TypographySize.xs}
          color={TypographyColor.fill}
        >
          {formatFileSize(size)}
        </Typography>
      </div>
    </a>
  );
};

export default React.memo(MessageDocument);
